import {
  IonButton,
  IonButtons,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonLoading,
  IonPopover,
  IonRow,
} from "@ionic/react";
import { addCircle } from "ionicons/icons";
// import AE2CustomerCampusList from "./AE2CustomerCampusList";
import "./AE2BuildingInfo.css";
import { useAppSelector } from "../../Hooks";
import { selectUser } from "../../reducers/UserReducer";
import UtilityServiceTable from "./UtilityServiceTable";
import EScoreCard from "../Energystar/EScoreCard";
import { isStaff } from "../extras/Functions";
import EnergyStarScoreLineGraph from "../Energystar/EnergyStarScoreLineGraph";
import Download8020InvoiceButton from "./BuildingPageComponents/Download8020InvoiceButton";
import DownloadBenchmarkReportButton from "./BuildingPageComponents/DownloadBenchmarkReportButton";
import CostAvoidanceReportButton from "./BuildingPageComponents/CostAvoidanceReportButton";
import BuildingInfoCard from "./BuildingPageComponents/BuildingInfoCard";
import ElectricityUseGraph from "./BuildingPageComponents/ElectricityUseGraph";
import GasUseGraph from "./BuildingPageComponents/GasUseGraph";
import DemandGraph from "./BuildingPageComponents/DemandGraph";
import WaterGraph from "./BuildingPageComponents/WaterGraph";
import HotWaterGraph from "./BuildingPageComponents/HotWaterGraph";
import ChilledWaterGraph from "./BuildingPageComponents/ChilledWaterGraph";
import CostAvoidanceGraph from "./BuildingPageComponents/CostAvoidanceGraph";
import CarbonEmissionsGraph from "./BuildingPageComponents/CarbonEmissionsGraph";
import BuildingOverview from "./BuildingPageComponents/BuildingOverview";
import { useEffect, useState } from "react";
import column_one from "../../AE2/static/icons/column-one.svg"
import column_two from "../../AE2/static/icons/columns-two.svg"
import column_three from "../../AE2/static/icons/columns-three.svg"
import ReloadDataButton from "../ReloadDataButton";
import MeterListTable from "./BuildingPageComponents/MetersListTable";
import SteamGraph from "./BuildingPageComponents/SteamGraph";
import IntervalData from "./BuildingPageComponents/IntervalData";
import usePermissionGroups from "../../utils/usePermissionGroups";
interface props {
  item: any;
}


const AE2BuildingInfo: React.FC<props> = ({ item }) => {
  let params = new URLSearchParams(window.location.search);
  const user = useAppSelector(selectUser);
  const [tab, setTab] = useState('energy_data')
  const role = user.role?.name;
  const [cols,setCols] = useState(2);
  const url_tab = params.get("t");

  const { hasPermission } = usePermissionGroups()
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';


  useEffect(()=>{
      if(url_tab){
        setTab(url_tab)
        const button = document.querySelector(`#${url_tab}_button`)
        button?.classList.add('selected')
      }  
      },[url_tab])

  const handleMenuClick = (e:any,page:string) =>{
        params.set("t",page)
        window.history.replaceState({},"",`?${params}`)
        setTab(page)
        const buttons: NodeListOf<Element>  = document.querySelectorAll(".energy-performance-menu-button")
        buttons.forEach((button:any)=>{
            button.classList.remove('selected')
        })
        e.target.classList.add('selected')

    }



  return (
    <>
      {!item ? (
        <IonLoading
          cssClass="my-custom-class"
          isOpen={!item}
          message={"Loading..."}
          spinner="bubbles"
          duration={10000}
        />
      ) : (
        <IonGrid className={newUI?'text-dark-blue':''}>
          <IonRow>
            <IonCol size="12" sizeMd="5">
              <BuildingInfoCard building={item}/>
            </IonCol>
            <IonCol size="12" sizeMd="3">
              {item.estar_id ? (
              <div className="center-all">
                <EScoreCard
                  property={item.baseline}
                  ae2={true}
                  building_id={item.uuid}
                ></EScoreCard>
              </div>
            ) : (
              ""
            )}
            </IonCol>
            <IonCol>
            <IonRow className="center-all" style={{flexDirection:'column'}}>
              <IonButtons style={{flexDirection:'column'}}>
                {isStaff(user) && hasPermission(['DownloadReports']) ? (
                  <>
                      {item.estar_id ? (
                        <>
                          <IonButton
                            id="reports-buttons"
                            fill="solid"
                            color="medium"
                            className="default-btn-size"
                            style={{margin:'0.25rem'}}
                          >
                            Reports
                          </IonButton>
                          <IonPopover
                            trigger="reports-buttons"
                            size="auto"
                            side="bottom"
                            alignment="start"
                            showBackdrop={false}

                          >
                            <IonContent  style={{"--background":"#6C7C84", margin: "1rem" }}>
                              <div style={{width:'100%', textAlign:'center', padding:'0.5rem'}}>
                              <DownloadBenchmarkReportButton id={item.uuid} name={item.building_name} />
                              <CostAvoidanceReportButton id={item.uuid} name={item.building_name} />
                              </div>
                            </IonContent>
                          </IonPopover>
                        </>
                      ) : (
                        ""
                      )}
                      <Download8020InvoiceButton id={item.uuid} name={item.building_name}/>
                      </>
                ) : (
                  ""
                )}
                <IonButton
                  className="default-btn-size"
                  color="medium"
                  fill="solid"
                  href={`/energy_performance?id=${item.uuid}`}
                  style={{margin:'0.25rem'}}
                >
                  Performance Details
                </IonButton>
              </IonButtons>
            </IonRow>
            </IonCol>
          </IonRow>

          <IonRow style={{'marginTop':'2rem'}}>
                <BuildingOverview building={item}/>
          </IonRow>


          
            <IonRow class="ion-justify-content-between" style={{width:'100%',borderBottom:'1px solid white'}}>
              <div style={{display:'flex'}}>
                <IonButton id='energy_data_button' 
                className= { tab === 'energy_data' ?  "selected energy-performance-menu-button" : 'energy-performance-menu-button'}
                fill='clear' color={newUI ? "dark" : "light"} 
                onClick={(e)=>handleMenuClick(e,'energy_data')}>Energy Data</IonButton>
                <IonButton id='interval_data_button' 
                className= { tab === 'interval' ?  "selected energy-performance-menu-button" : 'energy-performance-menu-button'}
                fill='clear' color={newUI ? "dark" : "light"}  
                onClick={(e)=>{handleMenuClick(e,'interval_data');setCols(3);}}>Interval Data</IonButton>
                <IonButton id='meters_button' className={ tab === 'meters' ?  "selected energy-performance-menu-button" : 'energy-performance-menu-button'} fill='clear' color={newUI ? "dark" : "light"}  onClick={(e)=>handleMenuClick(e,'meters')}>Meters</IonButton>                

              </div>
              {tab === 'energy_data' || tab === 'interval_data' ? 
              <div className="pc-only" style={{display:'flex',justifyContent:'right'}}>
                  <IonChip color={newUI ? "dark" : "light"}  onClick={()=>setCols(1)}>
                      <IonIcon style={{color:'white',margin:'0'}} src={column_one}/>
                  </IonChip>
                  <IonChip color={newUI ? "dark" : "light"}  onClick={()=>setCols(2)}>
                    <IonIcon style={{color:'white',margin:'0'}} src={column_two}/>
                  </IonChip>
                  <IonChip color={newUI ? "dark" : "light"}  onClick={()=>setCols(3)}>
                    <IonIcon style={{color:'white',margin:'0'}} src={column_three}/>
                  </IonChip>
            </div> : null }
            </IonRow>

          {tab === 'energy_data' ? 
          <div>
          <IonRow>
          <IonCol size="12" sizeMd={`${12/cols}`} style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Cost Avoidance</span>
              {item.campus_optimizer ? <div>{item.co_start_date}</div>:null}
              <ReloadDataButton id={item.uuid} type={'cost_avoidance'} style={{position:'absolute',right:'0', top:'20px'}} title="Reload Cost Avoidance Data"/>
            </h2>
            <CostAvoidanceGraph id={item.uuid}/>
          </IonCol>
            <IonCol size="12" sizeMd={`${12/cols}`}  className="score-dashboard-container" style={{  padding:'4rem',minHeight:'450px' }}>
              <h2 className="align-bottom utility-title" style={{textAlign:'center', marginBottom:'1.5rem'}}>
                <span className={newUI?'text-dark-blue':''}>Energy Star Score</span>
                <ReloadDataButton id={item.uuid} type={'estar_data'} style={{position:'absolute',right:'0', top:'20px'}} title="Reload Cost Energy Star Score Data"/>
              </h2>
              <EnergyStarScoreLineGraph id={item.uuid} />
            </IonCol>

            <IonCol size="12" sizeMd={`${12/cols}`}  style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Carbon Emissions</span>
              <ReloadDataButton id={item.uuid} type={'estar_data'} style={{position:'absolute',right:'0', top:'20px'}} title="Reload Carbon Emissions Data"/>
            </h2>
            <CarbonEmissionsGraph id={item.uuid}/>
            </IonCol>
            <IonCol size="12" sizeMd={`${12/cols}`}  style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Electricity Use</span>
              <ReloadDataButton id={item.baseline ? item.baseline.property.id : ''} type={'consumption'} title="Reload Electricity Use"/>
            </h2>
            <ElectricityUseGraph id={item.uuid} />
            </IonCol>
            <IonCol size="12" sizeMd={`${12/cols}`} style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Gas Use</span>
              <ReloadDataButton id={item.baseline ? item.baseline.property.id : ''} type={'consumption'} title="Reload Gas Use"/>
            </h2>
            <GasUseGraph id={item.uuid} />
            </IonCol>
            <IonCol size="12" sizeMd={`${12/cols}`} style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Demand</span>
              <ReloadDataButton id={item.baseline ? item.baseline.property.id : ''} type={'consumption'} title="Reload Demand Data"/>
            </h2>
            <DemandGraph id={item.uuid} />
            </IonCol>
            {item.has_water_meters ?
            <IonCol size="12" sizeMd={`${12/cols}`} style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Water Use</span>
              {/* <ReloadDataButton id={item.baseline ? item.baseline.property.id : ''} type={'consumption'} title="Reload Demand Data"/> */}
            </h2>            
            <WaterGraph id={item.uuid}/>
            </IonCol> : null }
            {item.has_steam_meters ?
            <IonCol size="12" sizeMd={`${12/cols}`} style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Steam Use</span>
              {/* <ReloadDataButton id={item.baseline ? item.baseline.property.id : ''} type={'consumption'} title="Reload Demand Data"/> */}
            </h2>            
            <SteamGraph id={item.uuid}/>
            </IonCol> : null }
            {item.has_chilled_water_meters ?
            <IonCol size="12" sizeMd={`${12/cols}`} style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Chilled Water Use</span>
              {/* <ReloadDataButton id={item.baseline ? item.baseline.property.id : ''} type={'consumption'} title="Reload Demand Data"/> */}
            </h2>            
            <ChilledWaterGraph id={item.uuid}/>
            </IonCol> : null }
            {item.has_hot_water_meters ?
            <IonCol size="12" sizeMd={`${12/cols}`} style={{  padding:'4rem',minHeight:'450px' }}>
            <h2 className="align-bottom utility-title" style={{textAlign:'center'}}>
              <span className={newUI?'text-dark-blue':''}>Hot Water Use</span>
              {/* <ReloadDataButton id={item.baseline ? item.baseline.property.id : ''} type={'consumption'} title="Reload Demand Data"/> */}
            </h2>            
            <HotWaterGraph id={item.uuid}/>
            </IonCol> : null }
          </IonRow>

          <div>
            { isStaff(user) ?
            <IonRow>
              <IonCol>
                <h2 className="align-bottom utility-title">
                  <span className={newUI?'text-dark-blue':''}>Utility Services:</span>
                  <IonButton
                    hidden={!(role === "Supervisor" || role === "Admin")}
                    size="small"
                    fill="clear"
                    color={newUI ? "dark" :"light"}
                    slot="icon-only"
                    href={`/building/${item.uuid}/utility_service`}
                  >
                    <IonIcon slot="icon-only" src={addCircle}></IonIcon>
                  </IonButton>
                </h2>
                <UtilityServiceTable utility_services={item.utility_services} />
              </IonCol>
            </IonRow> : null
      }
          </div>
          /</div> : null}

          {tab === 'meters' ? <MeterListTable id={item.uuid}/> :null}
          {tab === 'interval_data' ? <IntervalData id={item.uuid} cols={cols} baseline_date={item.interval_data_baseline_date}/> :null}

        </IonGrid>
      )}
    </>
  );
};

export default AE2BuildingInfo;
